var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("compensatory-request-search", {
    attrs: {
      "compensatory-request-search": _vm.compensatoryRequestSearch,
      "compensatory-request-search-init-filters":
        _vm.compensatoryRequestSearchInitFilters,
      "general-api": _vm.generalApi,
      "get-compensatory-request-general-info": _vm.getCompensatoryGeneralInfo,
      "get-compensatory-request-replacement":
        _vm.getCompensatoryRequestInterventions,
      "get-determination-reasons": _vm.getDeterminationReasons,
      "get-districts": _vm.getDistricts,
      "get-documents-by-student-service": _vm.getDocumentsByStudentService,
      "get-educational-documents-by-request":
        _vm.getEducationalDocumentsByRequest,
      "get-municipalities": _vm.getMunicipalities,
      "get-providers-by-academicyear-id": _vm.getProvidersByAcademicyearId,
      "get-regions": _vm.getRegions,
      "get-schools": _vm.getSchools,
      "get-service-locations": _vm.getServiceLocations,
      "get-specialist-by-provider-id": _vm.specialistsList,
      "get-visits": _vm.getVisits,
      "has-approval-permission": _vm.hasApprovalPermission,
      "has-closing-analysis-permission": _vm.hasClosingAnalysisPermission,
      "has-delete-permission": _vm.hasDeletePermission,
      "has-pending-approvement-last-status-permission":
        _vm.hasPendingApprovementLastStatusPermission,
      "has-pending-approvement-permission": _vm.hasPendingApprovementPermission,
      "is-intervention-are-approved": _vm.isInterventionAreApproved,
      "is-specialist": _vm.isSpecialist,
      "location-search-config-filters": _vm.locationSearchConfigFilters,
      "on-add-navigation": _vm.onAddNavigationHandler,
      "on-delete-request": _vm.onDeleteRequest,
      "on-determination-submit": _vm.onDeterminationSubmit,
      "on-download": _vm.onDownload,
      "on-download-referral-sheet": _vm.downloadReferralSheet,
      "on-history-navigation": _vm.onHistoryNavigation,
      "on-replace-document": _vm.replaceDocument,
      "on-request-navigation": _vm.onRequestNavigation,
      "on-visit-certification": _vm.getVisitsCertification,
      "on-visit-registry-navigation": _vm.onVisitRegistryNavigateHandler,
      "print-form": _vm.onPrintForm,
      "save-referral-item-attachment": _vm.saveReferralItemAttachment,
      "update-compensatory-request-status": _vm.updateCompensatoryRequestStatus,
      "update-request-status-to-previous": _vm.updateRequestStatusToPrevious,
      "view-add-action": _vm.viewAddAction,
      "view-determination-options": false,
      "view-menu-print-form": _vm.viewMenuPrintForm
    },
    on: { "on-click-return": _vm.onReturnHandler }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }